const SET_HAPPENING = 'SET_HAPPENING';
const SET_HAPPENING_NON_CONTENT = 'SET_HAPPENING_NON_CONTENT';
const SET_FILTERED_EVENTS = 'SET_FILTERED_EVENTS';

export {
    SET_HAPPENING, SET_HAPPENING_NON_CONTENT, SET_FILTERED_EVENTS
};
